module.exports = __webpack_public_path__ + "static/img/s3b.57277f5d.jpg";